import {
  enumLabel,
  INCLUSION_LABELS,
  EMPLOYER_CONTRIBUTION_LABELS,
} from "./shared";

const TIED_TO_ANOTHER_LOC_LABELS: Record<string, string> = {
  shortTermDisability: "STD",
  longTermDisability: "LTD",
  basicLifeAdnd: "Basic Life/AD&D",
  voluntaryLifeAdnd: "Vol. Life/AD&D",
  notIncluded: "Not Included",
  notTied: "Not Tied",
};

const freeText =
  (fieldKey: string) =>
  (row: Record<string, unknown>): string => {
    const value = row[fieldKey];
    return typeof value === "string" ? value : "";
  };

const count =
  (fieldKey: string) =>
  (row: Record<string, unknown>): string => {
    const value = row[fieldKey];
    return typeof value === "number" ? String(value) : "";
  };

const eapFormatters: Record<string, (row: Record<string, unknown>) => string> =
  {
    faceToFaceVisits: count("faceToFaceVisits"),
    perOccurrencePerYear: freeText("perOccurrencePerYear"),
    legalFinancialResources: freeText("legalFinancialResources"),
    additionalResourcesIncluded: freeText("additionalResourcesIncluded"),
    unlimitedTelephonic: enumLabel("unlimitedTelephonic", INCLUSION_LABELS),
    tiedToAnotherLoc: enumLabel("tiedToAnotherLoc", TIED_TO_ANOTHER_LOC_LABELS),
    employerContribution: enumLabel(
      "employerContribution",
      EMPLOYER_CONTRIBUTION_LABELS,
    ),
  };

export const formatEapField = (
  fieldId: string,
  row: Record<string, unknown>,
): string | undefined => {
  const formatter = eapFormatters[fieldId];
  return formatter ? formatter(row) : undefined;
};
